import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/CheckoutTransferencia.css';
import { API_URL } from '../config';


interface Producto {
  nombre: string;
  imagen: string;
  color: string;
  cantidad: number;
  precio: number;
}

interface CheckoutState {
  ordenId: number | string;
  total: number;
  carrito: Producto[];
}

const CheckoutTransferencia: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const state = (location.state || {}) as Partial<CheckoutState>;
  const { ordenId, total, carrito } = state;
  const productos: Producto[] = carrito || [];

  const [file, setFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!ordenId || !total) {
    return (
      <div className="transferencia-container">
        <h2>⚠️ Error</h2>
        <p>No se encontró información de la orden.</p>
        <button onClick={() => navigate('/')}>Volver al inicio</button>
      </div>
    );
  }

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = e.target.files?.[0] || null;
    setFile(selected);
    if (error) setError(null);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!file) {
      setError('Por favor sube el comprobante antes de enviar.');
      return;
    }

    const formData = new FormData();
    formData.append('comprobante', file);             // mismo nombre que espera tu vista
    formData.append('orden_id', String(ordenId));     // asegúrate de enviarlo como string

    setLoading(true);
    setError(null);

  try {
      // 1. La URL usa el Template Literal (comillas invertidas)
      const res = await fetch(`${API_URL}/api/subir_comprobante/`, 
        // 2. El segundo argumento es el objeto de configuración (sin comillas)
        {
          method: 'POST',
          body: formData,
          // 3. Comentario sobre headers: No incluir Content-Type
          // Si usas sesión/CSRF, descomenta SOLO estas líneas:
          // credentials: 'include',
          // headers: { 'X-CSRFToken': getCookie('csrftoken') || '' }, 
        } // 4. La coma estaba después de 'body' y faltaba el cierre del objeto.
      ); 

      // ... resto del código
      const ct = res.headers.get('content-type') || '';
      const data = ct.includes('application/json') ? await res.json() : await res.text();

      if (!res.ok) {
        const msg = typeof data === 'string' ? data : (data?.error || 'Error desconocido al subir el comprobante');
        throw new Error(msg);
      }

      alert('✅ Comprobante enviado correctamente');
      navigate(`/checkout-success?metodo=transferencia&orden_id=${ordenId}`);
    } catch (err: any) {
      console.error('Error al enviar comprobante', err);
      setError(err?.message || 'Ocurrió un error al enviar el comprobante');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="transferencia-container">
      <h2>Transferencia Bancaria</h2>

      {productos.length > 0 && (
        <div className="productos-carrito">
          <h4>Detalle de Productos:</h4>
          {productos.map((item, index) => (
            <div key={index} className="producto-item">
              <img src={item.imagen} alt={item.nombre} />
              <div className="producto-info">
                <p><strong>{item.nombre}</strong></p>
                <p>Color: {item.color}</p>
                <p>Cantidad: {item.cantidad}</p>
                <p>Precio: ${Number(item.precio).toLocaleString()}</p>
              </div>
            </div>
          ))}
        </div>
      )}

      <p>Tu número de orden es: <strong>{String(ordenId)}</strong></p>
      <p>Monto a pagar: <strong>${Number(total).toLocaleString()}</strong></p>

      <div className="datos-transferencia">
        <p><strong>Nombre:</strong> ProdNook Inc.</p>
        <p><strong>RUT:</strong> 78.243.576-0</p>
        <p><strong>Banco:</strong> Banco Estado</p>
        <p><strong>Cuenta Vista:</strong> 902-7-881230-7</p>
        <p><strong>Email:</strong> contacto@prodnook.cl</p>
      </div>

      <h3>Subir Comprobante</h3>

      {error && <div className="error">{error}</div>}

      <form onSubmit={handleSubmit} className="comprobante-form">
        <input type="file" accept="image/*" onChange={handleFileChange} />
        <button type="submit" disabled={loading}>
          {loading ? 'Enviando…' : 'Enviar Comprobante'}
        </button>
      </form>
    </div>
  );
};

export default CheckoutTransferencia;

